module.exports = __webpack_public_path__ + "static/media/StatFavoritesCircle.104704b7.svg";